import { resolveTemplate } from "@/modules/_shared/templateValue";
import type { CellModule } from "@/modules/_shared/contract";
import { computedFns } from "@/modules/_shared/engine";

export const computedModule: CellModule = {
  kind: "computed",
  capability: "cell",
  name: "Format Text",
  tooltip: "Change how the text looks (UPPERCASE, web link, and more)",
  description: "Takes a value and changes its format, like making it UPPERCASE, lowercase, or a web-friendly link.",
  category: "Rules",
  tags: ["function", "transform", "helper", "derive"],
  icon: { kind: "lucide", name: "FunctionSquare" },
  tone: "amber",
  defaultConfig: () => ({ kind: "computed", fn: "slugify", args: [""] }),
  resolve: (rule, { row, helpers, output }) => {
    if (rule.kind !== "computed") return "";
    const args = (rule.args ?? []).map((arg) => {
      if (typeof arg === "number") return String(arg);
      // Each arg may itself be a template — resolve against row + output.
      return resolveTemplate(arg, { row, helpers, output });
    });
    const fn = computedFns[rule.fn];
    if (!fn) return "";
    return fn(args, helpers);
  },
  templateStrings: (rule) =>
    rule.kind === "computed"
      ? (rule.args ?? []).filter((a) => typeof a !== "number")
      : [],
};
